import { useTranslation } from "react-i18next";

/**
 * `useTranslation` with a shallow-typed `t`.
 *
 * The project's typed `t` spans every typed namespace, so each `t("key")` call
 * instantiates a large union. Components that make many `t()` calls in JSX add
 * up and push TypeScript's cumulative instantiation budget over the limit,
 * surfacing as `TS2589` in whatever file happens to cross it. Paying that deep
 * instantiation once here, and handing callers a shallow `t`, keeps the whole
 * project comfortably under the ceiling.
 *
 * Use in components that make several `t()` calls directly in JSX. Content hooks
 * still prefer `tObj`/`tStr` (see `5-shared/utils/i18n`).
 */
export function useT(ns?: string | string[]) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { t, i18n } = useTranslation(ns as any);
  // Plain-string `t`: keys returning objects/arrays go through `tObj` instead.
  return { t: t as (key: string, opts?: Record<string, unknown>) => string, i18n };
}
